import React, {useEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './iconCart.css';
import {Col} from "react-bootstrap";

function IconCart({icon, header, content, color, lg, md, className, xl, AOSEffect = null, AOSDuration = 1000}) {
    useEffect(() => {
        AOSEffect && AOS.init({
            easing: 'ease-in-out', // نوع انیمیشن
            once: true, // فقط یک‌بار انیمیشن اجرا شود
        });
    }, []);
    return (
        <Col data-aos={AOSEffect} data-aos-duration={AOSDuration} xl={xl} lg={lg} md={md} className={`icon-card ${className}`}>
            <div style={{backgroundColor: `${color}`}} className={'p-4 rounded-3'}>
                <div>
                    <div className="f-icon">
                        <i className={`${icon}`}></i>
                    </div>
                </div>
                <h6 className={'mt-4 mb-3'}>{header}
                </h6>
                <p style={{textAlign:'right'}}>
                    {content}
                </p>
            </div>
        </Col>
    );
}

export default IconCart;